export enum DocumentCenterEvents {
  uploadDocumentButtonClicked = 'Upload Document Button Clicked',
  documentTypeOptionClicked = 'Document Type Option Clicked',
  documentTypeCleared = 'Document Type Cleared',
  documentTypeMenuClicked = 'Document Type Menu Clicked',
  documentTypeSearchPerformed = 'Document Type Search Performed',
  documentTypeSearchPerformedFromUpload = 'Document Type Search Performed From Upload',
  documentSensitiveUnflagged = 'Document Sensitive Unflagged',
  documentSensitiveFlagged = 'Document Sensitive Flagged',
  documentNameFieldClicked = 'Document Name Field Clicked',
  documentTypeApplyToAllClickedFromUpload = 'Document Type Apply to All Clicked From Upload',
  documentTypeOptionClickedFromUpload = 'Document Type Option Clicked From Upload',
  documentTypeMenuClickedFromUpload = 'Document Type Menu Clicked From Upload',
  documentTypeClearedFromUpload = 'Document Type Cleared From Upload',
  documentTypeOptionRemovedFromUpload = 'Document Type Option Removed From Upload',
  voidDocumentModalConfirmDeletionClicked = 'Void Document Modal Confirm Button Clicked',
  sensitiveFlaggedFromUpload = 'Document Sensitive Flagged From Upload',
  sensitiveUnflaggedFromUpload = 'Document Sensitive Unflagged From Upload',
  documentNameFieldClickedFromUpload = 'Document Name Field Clicked From Upload',
  documentRemoveFileClickedFromUpload = 'Document Remove File Clicked From Upload',
  uploadModalCancelClicked = 'Upload Modal Cancel Clicked',
  uploadModalCloseIconClicked = 'Upload Modal Close Icon Clicked',
  uploadModalUploadButtonClicked = 'Upload Modal Upload Button Clicked',
  editModalCloseIconClicked = 'Edit Modal Close Icon Clicked',
  editModalCancelClicked = 'Edit Modal Cancel Clicked',
  editModalSaveClicked = 'Edit Modal Save Clicked',
  documentTypeFilterMenuClicked = 'Document Type Filter Menu Clicked',
  documentTypeFilterMenuOptionClicked = 'Document Type Filter Menu Option Clicked',
  documentTypeUploadedByFilterMenuOptionClicked = 'Document Uploaded By Filter Menu Option Clicked',
  documentTypeUploadedByFilterMenuClicked = 'Document Uploaded By Filter Menu Clicked',
  uploadedByFilterMenuClicked = 'Uploaded By Filter Menu Clicked',
  uploadedByFilterMenuOptionClicked = 'Uploaded By Filter Menu Option Clicked',
  uploadDateFilterMenuClicked = 'Upload Date Filter Menu Clicked',
  uploadDateFilterMenuOptionClicked = 'Upload Date Filter Menu Option Clicked',
  uploadDateFilterLast7DaysSelected = 'Upload Date Filter Last 7 Days Selected',
  uploadDateFilterLast30DaysSelected = 'Upload Date Filter Last 30 Days Selected',
  uploadDateFilterLast1YearSelected = 'Upload Date Filter Last 1 Year Selected',
  uploadDateFilterDateRangeSelected = 'Upload Date Filter Date Range Selected',
  fileFormatFilterMenuClicked = 'File Format Filter Menu Clicked',
  fileFormatFilterMenuOptionClicked = 'File Format Filter Menu Option Clicked',
  searchDocumentsFieldClicked = 'Search Documents Field Clicked',
  fileEntryClicked = 'File Entry Clicked',
  fileKebabMenuOpened = 'File Kebab Menu Opened',
  fileKebabMenuEditClicked = 'File Kebab Menu Edit Clicked',
  fileKebabMenuDownloadClicked = 'File Kebab Menu Download Clicked',
  fileKebabMenuVoidClicked = 'File Kebab Menu Void Clicked',
  documentPreviewModalDownloadClicked = 'Document Preview Modal Download Clicked',
  documentPreviewModalExpandClicked = 'Document Preview Modal Expand Clicked',
  documentPreviewModalCloseClicked = 'Document Preview Modal Close Clicked',
  voidReasonMenuOptionClicked = 'Void Reason Menu Option Clicked',
  voidReasonMenuOpened = 'Void Reason Menu Opened',
  voidReasonWrongPatientChartSelected = 'Void Reason Wrong Patient Chart Selected',
  voidDocumentModalCancelClicked = 'Void Document Modal Cancel Clicked',
  voidDocumentModalCloseIconClicked = 'Void Document Modal Close Icon Clicked',
  voidDocumentModalConfirmClicked = 'Void Document Modal Void Button Clicked',
  emptyListViewUploadDocumentButtonClicked = 'Empty List View Upload Document Button Clicked',
}
